import React from 'react'
import SearchBar from './SearchBar'
import { MyPlan } from './MyPlan'

const PlansHistory = () => {
  return (
    <div className=''>
      <SearchBar />
      <div className='mx-5'>
      <MyPlan />
      </div>
    </div>
  )
}

export default PlansHistory






// import React, { useEffect, useState } from 'react';
// import { DataGrid } from "@mui/x-data-grid";
// import { MdDeleteOutline } from 'react-icons/md';
// import { FaRegEdit } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';
// // import ApiService from '../../Api/ApiService'; // Uncomment when API is ready
// import { DotLoaderComp } from '../../../components/DotLoader/index';
// import { ShowErrorToast, ShowSuccessToast } from '../../../components/toaster/toast';

// export const Plans = ({ setSelectedMenu }) => {
//   const navigate = useNavigate();
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // Dummy data
//   const dummyModules = [
//     { id: 1, name: 'Module A', type: 'Type 1', annual_limit: 5000, cover: 'Individual' },
//     { id: 2, name: 'Module B', type: 'Type 2', annual_limit: 10000, cover: 'Family' },
//     { id: 3, name: 'Module C', type: 'Type 3', annual_limit: 15000, cover: 'Corporate' },
//   ];

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       // Uncomment the below code to use the API
//       /*
//       try {
//         const { data } = await ApiService.getModules();
//         setRows(data);
//       } catch (err) {
//         console.error('Error fetching modules:', err);
//       } finally {
//         setLoading(false);
//       }
//       */
      
//       // Simulate API call with dummy data
//       setTimeout(() => {
//         setRows(dummyModules);
//         setLoading(false);
//       }, 1000);
//     };
//     fetchData();
//   }, []);

//   const handleRoute = (route, name, subtitle) => {
//     navigate(route);
//     setSelectedMenu({ title: name, subtitle });
//   };

//   const handleEdit = (row) => {
//     setSelectedMenu('Update plan Module', '');
//     navigate('/update-module', { state: { rowData: row } });
//   };

//   const handleDelete = async (id) => {
//     const isConfirmed = window.confirm("Are you sure you want to delete this module?");

//     if (!isConfirmed) {
//       return;
//     }

//     setLoading(true);

//     // Uncomment the below code to use the API for deletion
//     /*
//     try {
//       await ApiService.deleteModule(id);
//       ShowSuccessToast("Module deleted successfully!");

//       const { data } = await ApiService.getModules();
//       setRows(data);
//     } catch (err) {
//       ShowErrorToast("Failed to delete module.");
//       console.error('Error deleting module:', err);
//     } finally {
//       setLoading(false);
//     }
//     */

//     // Simulate delete action with dummy data
//     setTimeout(() => {
//       setRows((prevRows) => prevRows.filter((row) => row.id !== id));
//       ShowSuccessToast("Module deleted successfully!");
//       setLoading(false);
//     }, 500);
//   };

//   const columns = [
//     { field: "name", headerName: "Module Name", minWidth: 100, flex: 1 },
//     { field: "type", headerName: "Module", minWidth: 100, flex: 1 },
//     { field: "annual_limit", headerName: "Annual Limit", minWidth: 100, flex: 1 },
//     { field: "cover", headerName: "Cover For", minWidth: 100, flex: 1 },
//     {
//       field: "actions",
//       headerName: "Actions",
//       minWidth: 100,
//       flex: 0.5,
//       renderCell: (params) => (
//         <div className="flex h-full">
//           <FaRegEdit size={21} className="cursor-pointer text-[#333547]" onClick={() => handleEdit(params.row)} />
//           <MdDeleteOutline size={24} className="cursor-pointer text-[#EE1919]" onClick={() => handleDelete(params.row.id)} />
//         </div>
//       )
//     }
//   ];

//   if (loading) {
//     return (
//       <div style={{ backgroundColor: "#f9f7f2" }} className='h-screen flex items-center justify-center'>
//         <DotLoaderComp />
//       </div>
//     );
//   }

//   return (
//     <div className='bg-white px-5 py-7 rounded-lg min-h-[70vh] m-10'>
//       <div className="flex justify-between mb-5 md:flex-row flex-col">
//         <div className="relative">
//           <div className="absolute inset-y-0 start-0 flex justify-center items-center ps-3 pointer-events-none">
//             <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
//               <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
//             </svg>
//           </div>
//           <input
//             type="search"
//             id="default-search"
//             className="block w-full sm:w-[300px] md:w-[400px] lg:w-[500px] h-[40px] p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-full bg-gray-50 outline-none"
//             placeholder="Search..."
//             required
//           />
//         </div>
//         <div>
//           <button
//             type="button"
//             className='lg:w-[160px] text-nowrap w-full md:mt-0 mt-4 h-[46px] bg-orangeColor rounded-[10px] font-inter text-base font-bold text-white '
//             onClick={() => handleRoute('/create-module', 'Create plan Module', '')}
//           >
//             Create Module
//           </button>
//         </div>
//       </div>

//       <div className="h-96 w-full">
//         <DataGrid rows={rows} columns={columns} pageSize={5} />
//       </div>
//     </div>
//   );
// };
